import React from 'react'
import BoatsPage from './BoatsPage'

export default function SailboatsPage() {
  return <BoatsPage categoryFilter="Sejlbåd" titleOverride="Sejlbåde til salg" />
}
